
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/benefit",
      function () {
        return require("private-next-pages/benefit/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/benefit"])
      });
    }
  